export default __webpack_public_path__ + "static/media/hotpoint.7ace4203.svg";